<template>
  <v-col :lg="4" :md="6" :sm="12">
    <v-card>
      <v-img
        class="white--text align-end"
        :src="video.snippet.thumbnails.high.url"
        height="275"
      >
      </v-img>

      <v-card-title class="video-title">{{ video.snippet.title }}</v-card-title>

      <v-card-text class="text--primary">
        <div>{{ video.snippet.description }}</div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <a
          class="youtube-link"
          :href="'https://www.youtube.com/watch?v=' + video.id.videoId"
          target="_blank"
        >
          <v-btn color="red" text>
            Watch on YouTube
          </v-btn>
        </a>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: ["video"],
};
</script>

<style>
.video-title {
  word-break: normal !important;
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  width: 100% !important;
  padding-bottom: 5px !important;
}

.youtube-link {
  color: transparent !important;
}
</style>
